import { Dashboard } from "./Dashboard";
import { BarChartOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const DASHBOARD = {
    path: "/dashboard",
    component: Dashboard,
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    menu: {
        key: "Dashboard",
        label: "Dashboard",
        order: 0,
        icon: BarChartOutlined,
    },
};
